import { Component, OnInit, Input, OnChanges, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { LoggedLandingPageService } from 'src/app/core/services/logged-landing-page.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
declare var $: any;
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-publication',
  templateUrl: './publication.component.html',
  styleUrls: ['./publication.component.scss']
})
export class PublicationComponent implements OnInit {

  @Input() whichSection;
  @Input() contentId;
  @Input() passRoute;
  userData: any;
  isError: boolean = false;
  slider: any;
  errorMessage: string;
  imgURL: any = API_ENDPOINTS.BASE_URL;
  sliderActive = false;
  currentUser: any;
  @Input() publicationData;
  @ViewChild('owlCarousel', { static: false }) owlCarousel: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoWidth: true,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 5
      }
    },
    nav: true
  }
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) { }


  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
    // this.publicationData = this.publicationData.splice(0,5);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.publicationData && changes.publicationData.currentValue.length > 0 && changes.publicationData.currentValue.length < 5) {
      this.customOptions.responsive['1199'].items = changes.publicationData.currentValue.length;
      this.customOptions.loop = false;
    } else if (changes && changes.publicationData && changes.publicationData.currentValue.length >= 5) {
      this.customOptions.loop = true;
      this.customOptions.responsive['1199'].items = 5;
    }
    if(this.contentId && this.whichSection === 'publication'){
      this.owlCarousel.to(this.contentId);
    }
  }

  disableLeftClick(event: MouseEvent): void {
    if (event.button === 0) {
      event.preventDefault(); // Prevent the default left-click behavior
    }
  }


  publicationClick(id) {
    if (this._authService.isLoggednIn()) {
      if(this.passRoute){
        this._router.navigate(['/material-detail-page', id, 'public'], { queryParams: { whichRoute: 'dashboard', whichSection: 'publication' } })
      } else {
        this._router.navigate(['/material-detail-page', id, 'public'])
      }
    }
    else {
      this._router.navigate(['/material-detail', id, 'public'])
    }
  }
  // initializeSlider() {
  //   const _this = this;
  //   if(this.publicationData && this.publicationData.length > 4){
  //     setTimeout(() => {
  //       _this.owlCarousel.el.nativeElement.onwheel = function (e) {
  //         e.preventDefault();
  //         if (e.deltaY < 0) {
  //           _this.owlCarousel.next();
  //         } else {
  //           _this.owlCarousel.prev();
  //         }
  //         e.preventDefault();
  //       };
  //     }, 100);
  //   }

  // }

}
